export default __webpack_public_path__ + "static/media/menu-right.ad8b71d6.svg";